// @flow
import { fetchContractsSuccess, fetchContractsFailure } from './actions';
import { put, call, all, takeEvery } from 'redux-saga/effects';
import { tripica } from '../../../api';
import HandleErrorService from '../../../lib/handleError';
import type { ContractsActionType } from './actions';
import { setLoading } from '../../LoadingStatus/actions';
import Navigation from '../../../lib/navigation';
import { CommonActions } from '@react-navigation/native';
import { fetchAgreementsByProductOfferings } from '../../Agreements/actions';
import WizzeeLog from '../../../lib/wizzeeLog';

export function* getContractsSaga(action: ContractsActionType): Generator<*, *, *> {
  try {
    yield put(setLoading('fetchContracts', true));
    const contracts = yield call([tripica, 'getFilesGroupedByCharacteristicSubscriptionSerialNumber']);
    yield put(fetchContractsSuccess(contracts));
    yield put(fetchAgreementsByProductOfferings());
  } catch (e) {
    WizzeeLog.warn('[saga] getContracts', e);
    yield put(fetchContractsFailure(e));
    HandleErrorService.showToastError(e);
  } finally {
    yield put(setLoading('fetchContracts', false));
    yield call(Navigation.dispatch, CommonActions.navigate({ name: 'contracts' }));
  }
}

export default function*(): Generator<*, *, *> {
  yield all([takeEvery('FETCH_CONTRACTS', getContractsSaga)]);
}
